import { FetchResult } from 'apollo-boost';

import { updateCampaigns } from '../../graphql/mutations/grid/campaigns';
import {
    GdUpdateCampaignUnionInput,
    UpdateCampaigns
} from '../../typings/graphql-grid';
import { BaseMutationExecutor } from '../BaseMutationExecutor/BaseMutationExecutor';

export class CampaignsMutationExecutor extends BaseMutationExecutor {
    public async updateCampaigns(
        inputItems: GdUpdateCampaignUnionInput[],
        login: string
    ): Promise<FetchResult<UpdateCampaigns & { notSynced?: boolean }>> {
        return this.client.awaitMutate<UpdateCampaigns>({
            mutation: updateCampaigns,
            variables: {
                input: {
                    campaignUpdateItems: inputItems
                },
                login
            },
            login
        });
    }
}
